import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import { translate, Interpolate } from 'react-i18next';

import { MessageBoxFunctionalLayout, TextButton } from 'wix-style-react';

class UpdateConfirmation extends PureComponent {
  static propTypes = {
    t: func.isRequired,
    onCancel: func.isRequired,
    onUpdate: func.isRequired,
  };

  articleURL =
    'https://support.wix.com/en/article/adding-a-google-ads-conversion-tracking-tag-to-your-wix-site';

  render = () => {
    const { t, onCancel, onUpdate } = this.props;

    return (
      <MessageBoxFunctionalLayout
        title={<span>{t('update-confirmation.dialog.modal.header')}</span>}
        confirmText={t('update-confirmation.dialog.modal.update')}
        cancelText={t('update-confirmation.dialog.modal.cancel')}
        theme="blue"
        onCancel={onCancel}
        onOk={onUpdate}
      >
        <div>
          <Interpolate
            i18nKey={'update-confirmation.dialog.modal.title'}
            useDangerouslySetInnerHTML
          />
          &nbsp;
          <TextButton
            dataHook="footer-secondary-cta"
            onClick={() => {
              window.open(this.articleURL, '_blank');
            }}
          >
            {t('update-confirmation.dialog.modal.title.link')}
          </TextButton>
        </div>
      </MessageBoxFunctionalLayout>
    );
  };
}
export default translate()(UpdateConfirmation);
